import { __ } from '@wordpress/i18n';
import { PanelBody, Button } from '@wordpress/components';
import { useSelect, useDispatch } from '@wordpress/data';
import { createBlock } from '@wordpress/blocks';

// Canonical render order; the InspectorControls slot inserts each missing
// piece into the correct position regardless of how the user reordered.
const ORDER = ['core/image', 'core/heading', 'core/paragraph'];

function insertOrdered(existing, newBlock) {
  const newIndex = ORDER.indexOf(newBlock.name);
  const before = [];
  const after = [];
  existing.forEach((b) => {
    const i = ORDER.indexOf(b.name);
    if (i !== -1 && i < newIndex) {
      before.push(b);
    } else {
      after.push(b);
    }
  });
  return [...before, newBlock, ...after];
}

export default function ContentPanel({ clientId }) {
  const { replaceInnerBlocks } = useDispatch('core/block-editor');

  const innerBlocks = useSelect(
    (select) => select('core/block-editor').getBlock(clientId)?.innerBlocks ?? [],
    [clientId]
  );

  const has = (name) => innerBlocks.some((b) => b.name === name);
  const hasImage = has('core/image');
  const hasHeading = has('core/heading');
  const hasParagraph = has('core/paragraph');

  if (hasImage && hasHeading && hasParagraph) {
    return null;
  }

  const add = (name, attrs = {}) => () => {
    replaceInnerBlocks(
      clientId,
      insertOrdered(innerBlocks, createBlock(name, attrs)),
      false
    );
  };

  return (
    <PanelBody title={__('Item content', 'brandy-blocks')} initialOpen={true}>
      {!hasImage && (
        <Button
          variant="secondary"
          onClick={add('core/image')}
          style={{ width: '100%', marginBottom: 8, justifyContent: 'center' }}
        >
          {__('Add image', 'brandy-blocks')}
        </Button>
      )}
      {!hasHeading && (
        <Button
          variant="secondary"
          onClick={add('core/heading', { level: 3, placeholder: 'Item title…' })}
          style={{ width: '100%', marginBottom: 8, justifyContent: 'center' }}
        >
          {__('Add title', 'brandy-blocks')}
        </Button>
      )}
      {!hasParagraph && (
        <Button
          variant="secondary"
          onClick={add('core/paragraph', { placeholder: 'Description…' })}
          style={{ width: '100%', justifyContent: 'center' }}
        >
          {__('Add description', 'brandy-blocks')}
        </Button>
      )}
    </PanelBody>
  );
}
